import type { RefCallback } from 'react'
import styled from 'styled-components'

interface Props {
  activationRef: RefCallback<HTMLDivElement>
}

const ActivationSentinel = styled.div`
  height: 1px;
  width: 100%;
  pointer-events: none;
`

/**
 * In-flow sentinel for cro-facilities-rework-v2 exposure on offer + property pages.
 * Always mount at the shared facilities slot — never inside accordion content —
 * so control and variant share the same activation Y position.
 */
export function StructuredFacilitiesReworkStandaloneActivation({
  activationRef,
}: Props) {
  return (
    <ActivationSentinel
      ref={activationRef}
      aria-hidden="true"
      data-testid="structured-facilities-rework-activation-sentinel"
    />
  )
}
